export default __webpack_public_path__ + "static/media/bar-code.d2cd61f8.svg";